import PrivateRoute from 'components/PrivateRoute';
import { useRoutesComponent } from 'components/Routes/RoutesComponent.rules';
import Seo from 'components/Seo';
import { useMemo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { BUILD_PROFILE } from 'utils/buildProfile';
import { formatTitle, getSiteUrl } from 'utils/env';

export const RoutesComponent = () => {
  const { RoutesList } = useRoutesComponent();

  const siteUrl = useMemo(() => getSiteUrl(), []);

  const renderWithSeo = (route: (typeof RoutesList)[number]) => {
    const canonicalFromRoute = !route.path.includes(':') ? route.path : undefined;
    const canonicalPath = route.canonicalPath || canonicalFromRoute;
    const canonical = canonicalPath && siteUrl ? `${siteUrl}${canonicalPath}` : undefined;
    const defaultOgImage = BUILD_PROFILE.assets.defaultOgImagePath;
    const ogImage = route.ogImage || `${siteUrl}${defaultOgImage}`;

    return route.canonicalPath ? (
      <>
        <Seo
          title={formatTitle(route.title)}
          description={route.description}
          canonical={canonical}
          ogImage={ogImage}
        />
        {route.element}
      </>
    ) : (
      route.element
    );
  };

  return (
    <Routes>
      {RoutesList.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            route.isPrivate ? (
              <PrivateRoute requireAdmin={route.requireAdmin}>{renderWithSeo(route)}</PrivateRoute>
            ) : (
              renderWithSeo(route)
            )
          }
        />
      ))}

      <Route path="/admin" element={<Navigate to="/admin/listas" replace />} />
    </Routes>
  );
};
